import React, { useEffect, useState } from "react";
import API from "util/Api";
import CardBox from 'components/CardBox'
import FormFilter from "components/FormFilter";
import ActionsTable from "components/ActionsTable/TableList";

const UserListing = (props) => {
 
    const [userList, setUserList] = useState({
        title: 'Locations',
        headers: ['Name','Location', 'Attendance', 'CheckIn Time', 'Checkout Time', 'In Time'],
        body : [
        {
            name: {
                disabled: false,
                hidden: false,
                title: 'Name',
                type: 'input',
                value: 'Ram',
                key: 'name'
            },
            location: {
                disabled: false,
                hidden: false,
                title: 'Total Valets',
                type: 'input',
                value: 'Banashankari',
                key: 'location'
            },
            attendance: {
                disabled: false,
                hidden: false,
                title: 'Full Time',
                type: 'input',
                value: 'P',
                key: 'attendance'
            },
            check_in: {
                disabled: false,
                hidden: false,
                title: 'On Demand',
                type: 'input',
                value: '12/06/2023 - 10:00 AM',
                key: 'check_in'
            },
            check_out: {
                disabled: false,
                hidden: false,
                title: 'on_demand_present',
                type: 'input',
                value: '-',
                key: 'check_out'
            },
            in_time: {
                disabled: false,
                hidden: false,
                title: 'in_time',
                type: 'input',
                value: '-',
                key: 'in_time'
            }
        },
        {
            name: {
                disabled: false,
                hidden: false,
                title: 'Name',
                type: 'input',
                value: 'Nishanth',
                key: 'name'
            },
            location: {
                disabled: false,
                hidden: false,
                title: 'Total Valets',
                type: 'input',
                value: 'Banashankari',
                key: 'location'
            },
            attendance: {
                disabled: false,
                hidden: false,
                title: 'Full Time',
                type: 'input',
                value: 'P',
                key: 'attendance'
            },
            check_in: {
                disabled: false,
                hidden: false,
                title: 'On Demand',
                type: 'input',
                value: '12/06/2023 - 10:10 AM',
                key: 'check_in'
            },
            check_out: {
                disabled: false,
                hidden: false,
                title: 'on_demand_present',
                type: 'input',
                value: '-',
                key: 'check_out'
            },
            in_time: {
                disabled: false,
                hidden: false,
                title: 'in_time',
                type: 'input',
                value: '-',
                key: 'in_time'
            }
        },
        {
            name: {
                disabled: false,
                hidden: false,
                title: 'Name',
                type: 'input',
                value: 'Jeevan',
                key: 'name'
            },
            location: {
                disabled: false,
                hidden: false,
                title: 'Total Valets',
                type: 'input',
                value: 'Banashankari',
                key: 'location'
            },
            attendance: {
                disabled: false,
                hidden: false,
                title: 'Full Time',
                type: 'input',
                value: 'P',
                key: 'attendance'
            },
            check_in: {
                disabled: false,
                hidden: false,
                title: 'On Demand',
                type: 'input',
                value: '12/06/2023 - 9:50 AM',
                key: 'check_in'
            },
            check_out: {
                disabled: false,
                hidden: false,
                title: 'on_demand_present',
                type: 'input',
                value: '-',
                key: 'check_out'
            },
            in_time: {
                disabled: false,
                hidden: false,
                title: 'in_time',
                type: 'input',
                value: '-',
                key: 'in_time'
            }
        },]

    });

    return (
        <div>
             <ActionsTable
                tableHeading={'Active Users'}
                table={userList}
                actions={false}
            />
        </div>
    );
};
export default UserListing;